module.exports = __webpack_public_path__ + "e4921f4c3a6037f5f8cba2c48a80f29b.svg";